// Section-header actions on the income tab, sized like the KYC refresh action, the other
// section-level button on the customer pages.
export const actionButtonSx = {
  textTransform: 'none',
  borderRadius: '8px',
  fontSize: '13px',
  px: 1.5,
  height: '30px',
  minWidth: '80px',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
}

export const secondaryButtonSx = {
  ...actionButtonSx,
  color: '#344054',
  border: '1px solid #D0D5DD',
  '&:hover': { backgroundColor: 'transparent', border: '1px solid #D0D5DD' },
}
